import { BidderCatalog, SparkForPubAvailabilityUpdate, TfshapingBidderUpdate } from '@pubstack/common/src/bidderCatalog'
import { sortByNameOf } from '@pubstack/common/src/sort'
import { buildUrlWithSearchParams } from '@pubstack/ui/utils/url'
import { useMutation, useQuery } from '../api-client'

export const CATALOG_QUERY_KEYS = ['pbs', 'catalog']

/** The catalog by the name each bidder shows; the app's own catalog hook sorts with it too. */
export const sortByDisplayName = sortByNameOf<BidderCatalog>((bidder) => bidder.displayName)

export type useCatalogOptions = { isPbstckBidderCompatible?: boolean }

export const useCatalog = ({ isPbstckBidderCompatible }: useCatalogOptions = {}, enabled = true) => {
  const url = buildUrlWithSearchParams('/pbs/catalog', {
    isPbstckBidderCompatible: isPbstckBidderCompatible ? 'true' : undefined,
  })
  const queryResult = useQuery<BidderCatalog[]>({ url, keys: [...CATALOG_QUERY_KEYS, { isPbstckBidderCompatible }], enabled, select: sortByDisplayName })

  return { ...queryResult, data: queryResult.data || [] }
}

export const useCatalogBidder = (bidderId?: string) => {
  return useQuery<BidderCatalog>({ url: `/pbs/catalog/${bidderId}`, keys: [...CATALOG_QUERY_KEYS, 'bidder', bidderId || ''], enabled: !!bidderId })
}

export const useUpdateTfshapingBidder = (toasts = {}) =>
  useMutation<TfshapingBidderUpdate, BidderCatalog>({
    method: 'put',
    url: '/admin/bidder-catalog/tfshaping-bidder',
    collectionKeys: CATALOG_QUERY_KEYS,
    ...toasts,
  })

export const useUpdateSparkForPubAvailability = (toasts = {}) =>
  useMutation<SparkForPubAvailabilityUpdate>({
    method: 'put',
    url: '/admin/spark-for-pub/availability',
    collectionKeys: CATALOG_QUERY_KEYS,
    ...toasts,
  })
